import http from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl; // Assuming `apiUrl` is defined in config.json.

const addRole = async (values) => {
  const { data } = await http.post(`${apiUrl}/authenticate/roles`, values);
  return data;
};

const editRole = async (id, values) => {
  const { data } = await http.post(
    `${apiUrl}/authenticate/roles/update/${id}`,
    values
  );
  return data;
};

const deleteRole = async (id) => {
  const { data } = await http.post(`${apiUrl}/authenticate/roles/delete/${id}`);
  return data;
};
export { addRole, editRole, deleteRole };
